<template>
  <transition name="expand">
    <div v-if="addressStatus === AddressStatus.ADD_SUBPREMISE">
      <p>{{ $t('addressState.subpremiseMessage') }}</p>
    </div>
  </transition>
</template>

<script setup lang="ts">
import { ref, watch } from 'vue'
import { AddressStatus } from '@/interfaces/admin/places'

const props = defineProps({
  addressStatus: {
    type: String as () => AddressStatus | null,
    default: null
  },
  currentLine2: {
    type: String,
    default: ''
  }
})

const emit = defineEmits(['update-subpremise'])

const subpremiseInput = ref(props.currentLine2)

watch(() => props.currentLine2, (newValue) => {
  subpremiseInput.value = newValue
})
</script>

<style scoped lang="scss">
.expand-enter-active,
.expand-leave-active {
  transition: all 0.3s ease-in-out;
  transform-origin: top;
}

.expand-enter-from,
.expand-leave-to {
  opacity: 0;
  transform: scaleY(0);
}
</style>
